import { render } from "./AwesomeInput.vue?vue&type=template&id=f8bde96a&scoped=true"
import script from "./AwesomeInput.vue?vue&type=script&lang=js"
export * from "./AwesomeInput.vue?vue&type=script&lang=js"

import "./AwesomeInput.vue?vue&type=style&index=0&id=f8bde96a&scoped=true&lang=css"

import exportComponent from "F:\\code\\my_business\\giaiphapmmo_business_2023\\front_end\\company_for_tax\\admin_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8bde96a"]])

export default __exports__